import { ClassProvider } from '@angular/core';
import { BIMPLUS_TOKEN_FACTORY, BimplusTokenFactory } from '../';

export const defaultBimplusApiTokenProvider = (): ClassProvider => ({
  provide: BIMPLUS_TOKEN_FACTORY,
  useClass: BimplusTokenFactory,
});
